import SidebarHomeLink from "./SidebarHomeLink";
import SidebarLoansLink from "./SidebarLoansLink";
import SidebarSection from "./SidebarSection";

export default function MainSidebarSection() {
  return (
    <SidebarSection title="MAIN" className="sidebar-section--main">
      <SidebarHomeLink />
      <SidebarLoansLink />
    </SidebarSection>
  );
}
